module.exports = __webpack_public_path__ + "img/26-jeep-gladiator.856b525f.jpg";